import React, { useEffect, useState } from "react";
import Routes from "./routes/routes";
import {Provider} from 'react-redux';
import PersistedStore from "./store";
import { ThemeProvider, StyledEngineProvider, createTheme, adaptV4Theme } from '@mui/material/styles';
import LoadingScreen from "./container/frontend/loadingScreen";

const theme = createTheme(adaptV4Theme({
  typography: {
    fontFamily: '"Poppins", sans-serif'
    // fontFamily: 'Flexo'
  },}));
const store = PersistedStore.getDefaultStore().store;

const App = () => {
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setShowLoader(false);
    }, 1800);

    return () => window.clearTimeout(timer);
  }, []);

  return (
    <StyledEngineProvider injectFirst>
      {showLoader ? (
        <LoadingScreen />
      ) : (
        <ThemeProvider theme={theme}>
        <Provider store={store}>
          <Routes/>
        </Provider>
      </ThemeProvider>
      )}
    </StyledEngineProvider>
  );}

export default App;

// https://www.codementor.io/blog/react-optimization-5wiwjnf9hj#.YbD42UeP0l4.linkedin
